import React, { useState, useRef, useEffect } from 'react'
import PageTable from "../../components/pageComponents/PageTable";
import FormSelect from "../../components/atoms/Select";
import {handleFind} from "../../helper/utils";
import ActionsIcons from '../../components/atoms/ActionsIcons';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import ReactTooltip from 'react-tooltip';
import VerDetallePrestamoModal from './modales/VerDetallePrestamoModal';
import AprobarPrestamo from './modales/AprobarPrestamo';
import EditarPrestamo from './modales/EditarPrestamo';
import ReasignarAprobadorPrestamo from "./modales/ReasignarAprobadorPrestamo";

const TablePrestamosYAdelantos = ({
                        formValues,
                        setFormValues,
                        paginator,
                        setPaginator,
                        keys: KEYS,
                        fromAdminPage,
                        manageSearch={manageSearch},    
                        rolGestionDePrestamos,   
                        rolLiderEquipo,
                        rolDirector,
                        selectedIds = new Set(),
                        setSelectedIds = () => {},
                        selectAllRef = {current: null}
                    }) => {
    
    const rows = formValues.Items ?? [];
    
    // ── Estado modales ─────────────────────────────────────────────
    const [idPrestamoSeleccionado, setIdPrestamoSeleccionado] = useState(null);
    const [showDetalle, setShowDetalle]   = useState(false);
    const [showAprobar, setShowAprobar]   = useState(false);
    const [accionActual, setAccionActual] = useState(null); // "APROBAR" | "RECHAZAR" | "OBSERVAR"
    const [showEditar, setShowEditar] = useState(false);
    const [showReasignar, setShowReasignar] = useState(false);
    const [idPrestamoDetalle, setIdPrestamoDetalle] = useState(null);
    const [fechaIngresoDetalle, setFechaIngresoDetalle] = useState("");
    const [fechaIngresoEditar, setFechaIngresoEditar] = useState("");
    const [nivelActual, setNivelActual] = useState(null);
    
    // Datos para reasignación
    const [reasignarData, setReasignarData] = useState({
        idSolicitud: null,
        nombreEmpleado: "",
        nombreEmpleadoAprobador: ""
    });

    const handleVerDetalle = (row) => {
        setIdPrestamoDetalle(row.IdPrestamo);
        setFechaIngresoDetalle(row.FechaIngreso);
        setShowDetalle(true);
    };
    const handleAccion = (row, accion) => {
        setIdPrestamoSeleccionado(row.IdPrestamo);
        setFechaIngresoEditar(row.FechaIngreso);
        setAccionActual(accion);
        if (accion === "EDITAR") {
            setShowEditar(true);
        } else {
            setShowAprobar(true);
        }
    };

    const handleAbrirReasignar = (row) => {
        setReasignarData({
            idSolicitud:             row.IdPrestamo,
            nombreEmpleado:          row.Colaborador,
            nombreEmpleadoAprobador: row.NombreEmpleadoAprobador ?? ""
        });
        setShowReasignar(true);
    };

    const handleAbrirAccionDesdeEditar = (idPrestamo, accion, nivel) => {
        setIdPrestamoSeleccionado(idPrestamo);
        setAccionActual(accion);
        setNivelActual(nivel);
        setShowAprobar(true);
    };
    const handleAccionSuccess = async () => {
        setShowEditar(false);
        setShowAprobar(false);
        setShowDetalle(false);
        setShowReasignar(false);
        setNivelActual(null);
        await manageSearch();
    };
    const HANDLE_SELECT_ALL = (e) => {
        if (e.target.checked) {
            const selectableIds = rows
                .filter(row => row.IdEstadoProceso === 14 && !row.EnviadoAPlanillaBool)
                .map(row => row.IdPrestamo);
            setSelectedIds(new Set([...selectedIds, ...selectableIds]));
        } else {
            const selectableIds = rows
                .filter(row => row.IdEstadoProceso === 14 && !row.EnviadoAPlanillaBool)
                .map(row => row.IdPrestamo);
            setSelectedIds(new Set([...selectedIds].filter(id => !selectableIds.includes(id))));
        }
    };

    const handleRowCheck = (id, checked) => {
        const newSet = new Set(selectedIds);
        if (checked) {
            newSet.add(id);
        } else {
            newSet.delete(id);
        }
        setSelectedIds(newSet);
    };

    const visibleSelectableIds = rows.filter(row => row.IdEstadoProceso === 14 && !row.EnviadoAPlanillaBool).map(row => row.IdPrestamo);
    const allVisibleSelected = visibleSelectableIds.length > 0 && visibleSelectableIds.every(id => selectedIds.has(id));
    const someVisibleSelected = visibleSelectableIds.some(id => selectedIds.has(id));

    useEffect(() => {
        if (selectAllRef?.current) {
            selectAllRef.current.indeterminate = someVisibleSelected && !allVisibleSelected;
        }
    }, [someVisibleSelected, allVisibleSelected]);

    const HEADERS = [
        ...(fromAdminPage && rolGestionDePrestamos ? [{
            col: "col-sm-1",
            label: (
                <input type="checkbox"
                    ref={selectAllRef}
                    checked={allVisibleSelected}
                    onChange={HANDLE_SELECT_ALL}
                    style={{ cursor: 'pointer', width: '16px', height: '16px' }}
                />
            )
        }] : []),
        {col: "col-sm-1", label: "Fecha de Registro"},
        {col: "col-sm-2", label: "Colaborador"},
        {col: "col-sm-1", label: "Fec. Ingreso"},
        {col: "col-sm-1", 
            label: 
            <div className='d-flex justify-content-center'>
                <FormSelect
                    options={handleFind(formValues.filters, KEYS.IdsEstadoEmpleado)}
                    description="Est. Empleado"
                    selectedOptions={formValues.selectedFilters?.[KEYS.IdsEstadoEmpleado] ?? []}
                    setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsEstadoEmpleado)}
                />
            </div>
        },
        {col: "col-sm-2", 
            label:             
            <div className='d-flex justify-content-center'>
                <FormSelect
                    options={handleFind(formValues.filters, KEYS.IdsCargosPrestamo)}
                    description="Cargo"
                    selectedOptions={formValues.selectedFilters?.[KEYS.IdsCargosPrestamo] ?? []}
                    setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsCargosPrestamo)}
                />
            </div>
        },        
        {col: "col-sm-2", 
            label: 
            <div className='d-flex justify-content-center'>
                <FormSelect
                    options={handleFind(formValues.filters, KEYS.IdsSedesPrestamo)}
                    description="Sede"
                    selectedOptions={formValues.selectedFilters?.[KEYS.IdsSedesPrestamo] ?? []}
                    setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsSedesPrestamo)}
                />
            </div>
        },
        {col: "col-sm-1", 
            label: 
            <div className='d-flex justify-content-center'>
                <FormSelect
                    options={handleFind(formValues.filters, KEYS.IdsDepartamentosPrestamo)}
                    description="Departamento"
                    selectedOptions={formValues.selectedFilters?.[KEYS.IdsDepartamentosPrestamo] ?? []}
                    setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsDepartamentosPrestamo)}
                />
            </div>

        },
        {col: "col-sm-1", label: 
            <div className='d-flex justify-content-center'>
                <FormSelect
                    options={handleFind(formValues.filters, KEYS.IdsTipoSolicitudPrestamo)}
                    description="Tipo Solicitud"
                    selectedOptions={formValues.selectedFilters?.[KEYS.IdsTipoSolicitudPrestamo] ?? []}
                    setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsTipoSolicitudPrestamo)}
                />
            </div>
        },
        {col: "col-sm-1", label: 
            <div className='d-flex justify-content-center'>
                <FormSelect
                    options={handleFind(formValues.filters, KEYS.IdsMotivosPrestamo)}
                    description="Motivo"
                    selectedOptions={formValues.selectedFilters?.[KEYS.IdsMotivosPrestamo] ?? []}
                    setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsMotivosPrestamo)}
                />
            </div>
        },
        {col: "col-sm-1", label: 
            <div className='d-flex justify-content-center'>
                <FormSelect
                    options={handleFind(formValues.filters, KEYS.IdsEstadoProceso)}
                    description="Estado Proceso"
                    selectedOptions={formValues.selectedFilters?.[KEYS.IdsEstadoProceso] ?? []}
                    setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsEstadoProceso)}
                />
            </div>
        },
        {col: "col-sm-1", label: 
            <div className='d-flex justify-content-center'>
                <FormSelect
                    options={handleFind(formValues.filters, KEYS.IdsNivelesPrestamo)}
                    description="Nivel"
                    selectedOptions={formValues.selectedFilters?.[KEYS.IdsNivelesPrestamo] ?? []}
                    setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsNivelesPrestamo)}
                />
            </div>
        },
        {col: "col-sm-1", label: 
            <div className='d-flex justify-content-center'>
                <FormSelect
                    options={handleFind(formValues.filters, KEYS.IdsEnviadoAPlanilla)}
                    description="Env. Planilla"
                    selectedOptions={formValues.selectedFilters?.[KEYS.IdsEnviadoAPlanilla] ?? []}
                    setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsEnviadoAPlanilla)}
                />
            </div>
        },
        {col: "col-sm-1", label: "Monto"},
        {col: "col-sm-2", label: "Aprobador"},
        {col: "col-sm-2", label: "Acciones"},
    ]

    const handleFilterSelected = (res, key) => {
        const updatedSelectedFilters = {...formValues.selectedFilters, [key]: res};
        setFormValues(lastData => ({...lastData, selectedFilters: updatedSelectedFilters}));
    }
    

    return (
        <>
        {showEditar && idPrestamoSeleccionado && (
            <div className="modal-contactanos modal-response-ficha-background">
                <EditarPrestamo
                    idPrestamo={idPrestamoSeleccionado}
                    showModal={() => setShowEditar(false)}
                    refreshPage={manageSearch}
                    fromAdminPage={fromAdminPage}
                    fechaIngreso={fechaIngresoEditar}
                    esGestorPrestamos={rolGestionDePrestamos}
                />
            </div>
        )}

        {showDetalle && idPrestamoDetalle && (
            <div className="modal-contactanos modal-response-ficha-background">
                <VerDetallePrestamoModal
                    idPrestamo={idPrestamoDetalle}
                    showModal={() => setShowDetalle(false)}
                    fromAdminPage={fromAdminPage}
                    puedeAprobarRechazar={formValues.ExtraData?.PuedeAprobarRechazar}
                    puedeObservar={formValues.ExtraData?.PuedeObservar}
                    esGestorPrestamos={rolGestionDePrestamos}
                    onAbrirAccion={handleAbrirAccionDesdeEditar}
                    fechaIngreso={fechaIngresoDetalle}
                    rolLiderEquipo={rolLiderEquipo}
                    rolDirector={rolDirector}
                />
            </div>
        )}

        {showAprobar && idPrestamoSeleccionado && accionActual && (
            <div className="modal-contactanos modal-response-ficha-background">
                <AprobarPrestamo
                    idPrestamo={idPrestamoSeleccionado}
                    accion={accionActual}
                    showModal={() => setShowAprobar(false)}
                    refreshPage={handleAccionSuccess}
                    nivel={nivelActual}
                />
            </div>
        )}

        {/* ── Modal Reasignar Aprobador ── */}
        {showReasignar && (
            <div className="modal-contactanos modal-response-ficha-background">
                <ReasignarAprobadorPrestamo
                    toggleModal={() => setShowReasignar(false)}
                    refreshPage={handleAccionSuccess}
                    idSolicitud={reasignarData.idSolicitud}
                    nombreEmpleado={reasignarData.nombreEmpleado}
                    nombreEmpleadoAprobador={reasignarData.nombreEmpleadoAprobador}
                />
            </div>
        )}

        <PageTable headers={HEADERS} paginator={paginator} setPaginator={setPaginator}>
            <tbody className="listar-tbody">
                {rows.map((row) => (
                    <tr key={row.IdPrestamo}>
                        {fromAdminPage && rolGestionDePrestamos && (
                            <td className="text-center">
                                {row.IdEstadoProceso === 14 && !row.EnviadoAPlanillaBool && (
                                    <input type="checkbox"
                                        checked={selectedIds.has(row.IdPrestamo)}
                                        onChange={(e) => handleRowCheck(row.IdPrestamo, e.target.checked)}
                                        style={{ cursor: 'pointer', width: '16px', height: '16px' }}
                                    />
                                )}
                            </td>
                        )}
                        <td className="text-center">{row.FechaRegistro}</td>
                        <td className="text-center">{row.Colaborador}</td>
                        <td className="text-center">{row.FechaIngreso}</td>
                        <td className="text-center">{row.DesEstadoEmpleado}</td>
                        <td className="text-center">{row.DesCargo}</td>
                        <td className="text-center">{row.Sede}</td>
                        <td className="text-center">{row.DesDepartamento}</td>
                        <td className="text-center">{row.TipoSolicitud}</td>
                        <td className="text-center">{row.MotivoPrestamo}</td>
                        <td className="text-center">{row.EstadoProceso}</td>
                        <td className="text-center">{row.Nivel}</td>
                        <td className="text-center">{row.EnviadoAPlanilla}</td>
                        <td className="text-center">{row.Monto}</td>                        
                        <td className="text-center">{row.NombreEmpleadoAprobador}</td>
                        <td className="text-center">
                            <ActionsIcons>
                                {(row.MotivoRechazo || row.MotivoObservacion) && (
                                    <ToolTip id={`Motivo${row.IdPrestamo}`} text={row.MotivoRechazo || row.MotivoObservacion} />
                                )}
                                <FontAwesomeIcon icon="id-card" size="lg" title="Ver detalle"
                                    onClick={() => handleVerDetalle(row)} />

                                {/* Editar visible en la vista "MisPrestamos_y_adelantos" solo si registro está observado (13) */}
                                {!fromAdminPage && row.IdEstadoProceso === 13
                                    && !formValues.ExtraData?.EsSoloVisualizador && (
                                    <FontAwesomeIcon icon='edit' size="lg"  style={{color:'black !important'}}
                                        className="hand-pointer black-color"
                                        title="Editar solicitud"
                                        onClick={() => handleAccion(row, "EDITAR")} />
                                )}                                                               

                                {fromAdminPage && (
                                    <>
                                        {!formValues.ExtraData?.EsSoloVisualizador && (
                                            <>
                                            {/* {!rolGestionDePrestamos && (
                                                <FontAwesomeIcon icon='edit' size="lg"
                                                    className="hand-pointer black-color"
                                                    title="Editar solicitud"
                                                    onClick={() => handleAccion(row, "EDITAR")} />
                                            )} */}
                                            {rolGestionDePrestamos && row.IdEstadoProceso !== 15 && (
                                                <FontAwesomeIcon icon='edit' size="lg"
                                                    className="hand-pointer black-color"
                                                    title="Editar solicitud"
                                                    onClick={() => handleAccion(row, "EDITAR")} />
                                            )}
                                            {rolGestionDePrestamos && row.IdEstadoProceso === 15 && row.IdNivelAprobacion=== 2 && (
                                                <FontAwesomeIcon icon='undo' size="lg"
                                                    className="hand-pointer"
                                                    title="Revertir solicitud"
                                                    onClick={() => handleAccion(row, "REVERTIR")} />
                                            )}

                                            {/* ── Reasignar Aprobador (Gestor GDH: PuedeReasignar) ── */}
                                            {rolGestionDePrestamos &&
                                                formValues.ExtraData?.PuedeReasignar &&
                                                row.IdNivelAprobacion === 1 &&
                                                row.IdEstadoProceso === 44 && (
                                                <FontAwesomeIcon
                                                    icon="male"
                                                    size="lg"
                                                    title="Reasignar Aprobador"
                                                    className="hand-pointer"
                                                    onClick={() => handleAbrirReasignar(row)}
                                                />
                                            )}

                                            </>
                                        )}
                                    </>
                                )}
                            </ActionsIcons>
                        </td>
                    </tr>
                ))}
            </tbody>
        </PageTable>
        </>
    );
}

const ToolTip = ({ id, text }) => (
    <div>
        <FontAwesomeIcon data-tip data-for={id} icon='info-circle' title='Motivo' size='lg'
            style={{ color: "#b3a11a" }} />
        <ReactTooltip id={id} place="top" effect="solid" className="tooltip-style">
            {text}
        </ReactTooltip>
    </div>
)

export default TablePrestamosYAdelantos